import React from 'react';

// Styles
import Styles from './spinner.module.scss';

function Spinner({ className }) {
  return <div className={`${Styles['loader']} ${className}`}></div>;
}

export default Spinner;
